import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import VMSControlSignDetails from './VMSControlSignDetails'; // Adjust the import path as needed

/**
 * VMSControlStationGroup Component
 * Renders a group of Variable Message Sign (VMS) controls for a specific location.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.locationName - The name of the location for the VMS signs.
 * @param {Array} props.vmsSigns - The array of VMS sign objects.
 * @returns {JSX.Element} - The rendered VMSControlStationGroup component.
 */
const VMSControlStationGroup = ({ locationName, vmsSigns }) => {
  // Ensure we always have at least 2 columns, even if one is empty
  const signsToDisplay = vmsSigns.length % 2 !== 0 ? [...vmsSigns, null] : [...vmsSigns];

  return (
    <Card className="mb-4 no-border">
      <Card.Header className="text-center" style={{ background: 'transparent', borderBottom: '0px' }}>
        <div className="vms-station-header">{locationName}</div>
      </Card.Header>
      <Card.Body className="">
        <Row>
          {signsToDisplay.map((sign, index) => (
            <Col key={index} className="p-2">
              {sign ? <VMSControlSignDetails sign={sign} /> : <div className="empty-sign" />}
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default VMSControlStationGroup;
